import { render, staticRenderFns } from "./vue-ztree.vue?vue&type=template&id=5d8fd4b8&"
import script from "./vue-ztree.vue?vue&type=script&lang=js&"
export * from "./vue-ztree.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./vue-ztree.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

component.options.__file = "vue-ztree.vue"
export default component.exports